export const translations: Record<string, string> = {
    "name": "Jméno",
    "address": "Adresa",
    "birthDate": "Datum narození",
    "idNumber": "Číslo občasnkého průkazu",
    "accommodationType": "Typ ubytování",
    "participationFee": "Účastnický poplatek",
    "phoneNumber":  "Telefonní číslo",
    "membershipNumber": "Číslo členství",
    "stayDates-multiple":  "Termíny pobytu (multiple)",
    "eveningParticipation":  "Účast na večerním programu",
    "feeType":  "Typ poplatku",
    "nameOfAccommodation":  "Jméno ubytování",
    "placeOfAccommodation":  "Místo ubytování",
    "email": "E-mail",
    "stayDates-single": "Termín pobytu (single)",
    "nameOfAccomodation": "Jméno ubytování",
    "placeOfAccomodation": "Místo ubytování",
    "firstName": "Jméno",
    "lastName": "Příjmení"
}